<template>
    <b-modal
        :visible="isOpen"
        :lazy="true"
        title-tag="h2"
        :title="modalTitle"
        no-close-on-backdrop
        no-close-on-esc
    >
        <form @submit.prevent>
            <b-form-group
                label-for="diagnosis_val"
                label-cols="3"
                label="Diagnosis:"
            >
                <b-form-input
                    id="diagnosis_val"
                    ref="inputDiagnosis"
                    v-model="diagnosis"
                    name="diagnosis"
                    autofocus
                    :placeholder="placeholder"
                    v-validate="{ required: true }"
                    :class="{ 'border-danger': errors.has('diagnosis') }"
                    :disabled="isSaving"
                ></b-form-input>
            </b-form-group>
        </form>

        <template v-slot:modal-footer>
            <div v-if="isSaving" class="preloader">
                <img src="assets/ajax-loader.gif" />
            </div>

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isSaving"
            >
                Cancel
            </b-button>

            <b-dropdown
                left
                split
                xtext="Save + Done"
                :text="isSaveModeRepeat ? 'Save + New' : 'Save + Done'"
                variant="primary"
                @click="save(isSaveModeRepeat ? true : false)"
                v-if="!isSaving && mode === constant.NEW && !saveOnce"
            >
                <b-dropdown-item @click="save(isSaveModeRepeat ? false : true)">
                    {{ isSaveModeRepeat ? "Save + Done" : "Save + New" }}
                </b-dropdown-item>
            </b-dropdown>

            <b-button
                variant="primary"
                v-if="!isSaving && mode === constant.NEW && saveOnce"
                @click="save(false)"
            >
                Save
            </b-button>

            <b-button
                variant="primary"
                v-if="!isSaving && mode === constant.EDIT"
                @click="save(false)"
            >
                Save
            </b-button>
        </template>
    </b-modal>
</template>

<script>
const NEW = "NEW";
const EDIT = "EDIT";
const REPEAT = "REPEAT";

export default {
    props: {
        reloadAfter: {
            type: Boolean
        }
    },
    data() {
        return {
            constant: { REPEAT, NEW, EDIT },
            diagnosis: "",
            isSaving: false,
            isSaveModeRepeat: false,
            isOpen: false,
            mode: null,
            record: {},
            placeholder: "Complaint (required)",
            saveOnce: false
        };
    },
    watch: {
        visible(value) {
            // apply edit record
            if (value === true && this.mode === EDIT) {
                this.diagnosis = this.record.description;
            }
        }
    },
    computed: {
        modalTitle() {
            if (this.mode === NEW) {
                return "New Diagnosis";
            } else if (this.mode === EDIT) {
                return "Edit Diagnosis";
            }

            return "Diagnosis";
        }
    },
    methods: {
        open({ mode, saveOnce = false, placeholder = "", record, text = "" }) {
            this.mode = mode;
            this.isOpen = true;
            this.isSaving = false;
            this.saveOnce = saveOnce;

            if (placeholder !== "") {
                this.placeholder = placeholder;
            }

            if (text !== "") {
                this.diagnosis = text;
            }

            if (mode === EDIT) {
                this.record = record;
                this.diagnosis = record.description;
            }
        },
        close() {
            this.isOpen = false;
            this.record = {};
        },
        async save(isRepeat = false) {
            const isClear = await this.$validator.validateAll();

            if (!isClear) {
                return;
            }

            try {
                this.isSaving = true;
                let res;

                // edit diagnosis
                if (this.mode === EDIT) {
                    res = await this.$http.put(
                        `${process.env.BARRAMUNDI}account/custom-diagnosis/${this.record.id}`,
                        {
                            description: this.diagnosis
                        }
                    );

                    this._message("Diagnosis updated");
                }

                // new diagnosis
                else if (this.mode === NEW) {
                    res = await this.$http.post(
                        `${process.env.BARRAMUNDI}account/custom-diagnosis`,
                        {
                            description: this.diagnosis
                        }
                    );

                    this._message("Diagnosis created");
                }

                // reload list
                if (this.reloadAfter) {
                    this.$emit("reloadlist");
                }

                this.$emit("saved", res.data.response.resource);

                if (isRepeat) {
                    this.isSaving = false;
                    this.diagnosis = "";
                    this.isSaveModeRepeat = true;
                } else {
                    this.close();
                }
            } catch (e) {
                console.log(e.message);
            }
        }
    }
};
</script>

<style scoped>
.preloader {
    margin: 8px 0;
}
</style>
